// src/pages/pharmacies/index.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

import LayoutShell from "@/components/ui/LayoutShell.jsx";
import TopBarCenter from "@/sot/primitives/TopBarCenter.jsx";
import PharmacyResultCard from "@/components/pharmacies/PharmacyResultCard.jsx";
import PharmaciesFilterSheet from "@/pages/pharmacies/PharmaciesFilterSheet.jsx";
import { useLanguage } from "@/contexts/LanguageContext.jsx";

const PHARMACIES = [
  {
    id: "okavango",
    name: "Okavango Pharmacy",
    address: "Plot 36415, Mall of Maun, Shop 21, Maun",
    image: "/assets/images/pharmacies/Okavango Pharmacy.webp",
    distance: "5 km away",
    rating: null,
    isFavorite: true,
  },
  {
    id: "miam",
    name: "Miam Pharmacy",
    address: "Extension 12, Gaborone, Plot 3417",
    image: "/assets/images/pharmacies/Miam pharmacy.jpg",
    distance: "6 km away",
    rating: null,
    isFavorite: false,
  },
  {
    id: "bettercare",
    name: "BetterCare Pharmacy",
    address: "Serowe, Palapye, Botswana",
    image: "/assets/images/pharmacies/Bettercare Pharmacy-1.jpg",
    distance: "7 km away",
    rating: null,
    isFavorite: false,
  },
  {
    id: "reld-med",
    name: "Reld Med Pharmacy",
    address: "Unit 10, Plot 469170, Bleu Jacket Street, Francistown",
    image: "/assets/images/pharmacies/Reld Med Pharmacy.jpg",
    distance: "7.4 km away",
    rating: null,
    isFavorite: false,
  },
  {
    id: "dis-chem-francistown",
    name: "Dis-Chem Pharmacy – Gallo Centre",
    address: "Francistown, Botswana",
    image: "/assets/images/pharmacies/Dis-Chem Pharmacy.jpg",
    distance: "7.4 km away",
    rating: null,
    isFavorite: true,
  },
  {
    id: "ok-plus",
    name: "OK Plus Pharmacy",
    address: "Unit 22, Lobatse Junction Mall, Lobatse",
    image: "/assets/images/pharmacies/Ok Plus Pharmacy.jpg",
    distance: "8 km away",
    rating: null,
    isFavorite: false,
  },
];

export default function PharmaciesPage() {
  const nav = useNavigate();
  const { t } = useLanguage();

  // Filter state mirrors PharmaciesFilterSheet: { data: [...], payment: [...] }
  const [filters, setFilters] = React.useState({
    data: ["near-you"],
    payment: [],
  });

  const [isFilterOpen, setIsFilterOpen] = React.useState(false);

  const activeFilterCount = React.useMemo(() => {
    const d = filters.data?.length || 0;
    const p = filters.payment?.length || 0;
    return d + p;
  }, [filters]);

  return (
    <>
      <LayoutShell>
        <div className="afrimed-rail afrimed-rail--comfortable px-4 pt-4 pb-24">
          {/* Top bar – Pharmacies */}
          <header className="mb-4">
            <TopBarCenter
              title={t("appointments.directory.pharmacies.title", "Pharmacies")}
              close
              onBack={() => nav(-1)}
            />

            {/* Subtitle row – text left, Filter right */}
            <div className="mt-3 flex items-center justify-between px-1">
              <h2 className="text-title-medium text-on-surface-var">
                {t("appointments.directory.pharmacies.subtitle", "Pharmacies near you")}
              </h2>

              <button
                type="button"
                onClick={() => setIsFilterOpen(true)}
                className="inline-flex items-center gap-1 text-body-medium text-primary"
              >
                <img
                  src="/icons/patient/filter.svg"
                  alt=""
                  className="h-[18px] w-[18px]"
                  draggable="false"
                />
                <span>
                  {t("appointments.directory.common.filter", "Filter")}
                  {activeFilterCount > 0 ? ` · ${activeFilterCount}` : ""}
                </span>
              </button>
            </div>
          </header>

          {/* Results list – stacked cards */}
          <section className="space-y-3">
            {PHARMACIES.map((pharmacy) => (
              <PharmacyResultCard key={pharmacy.id} pharmacy={pharmacy} />
            ))}
          </section>
        </div>
      </LayoutShell>

      {/* Filter sheet */}
      <PharmaciesFilterSheet
        open={isFilterOpen}
        value={filters}
        onChange={setFilters}
        onClose={() => setIsFilterOpen(false)}
      />
    </>
  );
}
